'use client';
import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

import '@STYLE/styles/yfund/animate.css';
import '@STYLE/styles/yfund/bootstrap.css';
import '@STYLE/styles/yfund/common.css';
import '@STYLE/styles/yfund/content.css';
import '@STYLE/styles/yfund/reset.css';
import '@STYLE/styles/yfund/responsive.css';
import '@STYLE/styles/yfund/style.css';
import '@STYLE/styles/yfund/swiper.css';

export default function About() {
  const pathname = usePathname(); // 현재 경로
  const router = useRouter();

  useEffect(() => {
    if(!$('header').hasClass('scrolled')) {
      $('header').addClass('scrolled');
    }

    return () => {
      $('header').removeClass('scrolled');
    }
  }, []);

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();

      // 히스토리를 덮어쓰고 홈으로 이동
      history.replaceState(null, '', window.location.pathname);
      router.replace('/'); // Next.js App Router 방식
    };

    window.addEventListener('popstate', handlePopState);

    if(window.kakao) {
      var position = new kakao.maps.LatLng(37.51588524471231, 126.72679702096328);
      var container = document.getElementById('map'); //지도를 담을 영역의 DOM 레퍼런스
      var options = { //지도를 생성할 때 필요한 기본 옵션
        center: position, //지도의 중심좌표.
        level: 3 //지도의 레벨(확대, 축소 정도)
      };
  
      var map = new kakao.maps.Map(container, options); 
  
      var marker = new kakao.maps.Marker({
        position: position
      });

      marker.setMap(map);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [pathname, router]);



  return (
    <>
      {/* <Ask /> */}
      <div id="sub" className="company company_idx">
        <section className="sub_visual sub_video">
          <div className="video_box">
            <video muted={true} playsInline={true} autoPlay={true} loop={true}>
              <source src="/img/video/sub_company_visual_video_2.mov" />
            </video>
          </div>
          <div className="txt_box row_cen">
            <div className="container">
              <div className="video_tit">
                <p>OUR STORY</p>
                <strong>About Us</strong>
              </div>
            </div>
          </div>
        </section>
        {/* //sub_visual */}
        <div id="content">
          {/* <section className="section section1">
            <div className="container">
              <div className="sec_tit big faster" data-animate="fadeInUp">
                <strong>What We Do</strong>
              </div>
              <div className="sec_con">
                <div className="struct_box struct_box_pc row_cen">
                  <div
                    className="left side blue_sh col_cen faster"
                    data-animate="fadeInUp"
                  >
                    <div className="img">
                      <img src="/img/sub_loan_sec2_ico_2.png" />
                    </div>
                    <div className="txt">
                      <em>투자자</em>
                      <div className="type">
                        <p>
                          개인, 고액자산가, 법인,
                          <i className="dpb" />
                          금융기관
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="to_right">
                      <p className="arrow_bar" />
                    </div>
                    <div className="to_left">
                      <p className="arrow_bar" />
                    </div>
                  </div>
                  <div
                    className="mid faster"
                    data-animate="fadeInUp"
                    data-delay={100}
                  >
                    <div className="img row_cen">
                      <img src="/img/logo.svg" />
                    </div>
                  </div>
                  <div className="arrow">
                    <div className="to_right">
                      <p className="arrow_bar" />
                    </div>
                    <div className="to_left">
                      <p className="arrow_bar" />
                    </div>
                  </div>
                  <div
                    className="right side blue_sh col_cen faster"
                    data-animate="fadeInUp"
                    data-delay={200}
                  >
                    <div className="img">
                      <img src="/img/sub_loan_sec2_ico_1.png" />
                    </div>
                    <div className="txt">
                      <em>차입자</em>
                      <div className="type">
                        <p>
                          개인, 소상공인,
                          <i className="dpb" />
                          중소기업
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="struct_box_mo">
                  <div
                    className="img faster"
                    data-animate="fadeInUp"
                    data-delay={100}
                  >
                    <img src="/img/sub_company_sec1_img_mo.png" />
                  </div>
                </div>
                <div
                  className="struct_txt faster"
                  data-animate="fadeInUp"
                  data-delay={300}
                >
                  <p>
                    와이펀드는 투자자와 차입자를
                    <i className="inb" /> 온라인으로 직접 연결하는 금융 플랫폼입니다.
                  </p>
                  <p>
                    투자자에게는 안정적인 이자수익을,
                    <i className="inb" /> 차입자에게는 합리적인 이자비용을 제공합니다.
                  </p>
                  <div className="struct_guide">
                    <p>
                      와이펀드는 금융위원회에 정식 등록된
                      <i className="inb" /> 제도권 온라인투자연계금융 기업입니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* //section1 */}
          {/* <section className="section section2">
            <div className="container thin">
              <div className="sec_tit big faster" data-animate="fadeInUp">
                <strong>Our Leadership</strong>
              </div>
              <div className="sec_con">
                <div className="top row_cen">
                  <div className="img img_pc">
                    <img src="/img/sub_company_sec2_img_1.jpg" />
                  </div>
                  <div className="txt_box">
                    <div className="img img_mo">
                      <img src="/img/sub_company_sec2_img_1.jpg" />
                    <div className="info_box">
                      <div className="info_tit">
                        <i>CEO / Founder</i>
                      </div>
                      <div className="info_list">
                        <em>이유강, CFA</em>
                        <ul>
                          <li>
                            <p>워싱턴대학교 경영학</p>
                          </li>
                          <li>
                            <p>Altavair, Morgan Stanley, Amazon</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="team_list">
                  <ul className="row">
                    <li className="col-6 col-sm-4 col-md-3">
                      <div
                        className="img back_img normal_sh"
                        style={{
                          backgroundImage: "url(/img/sub_company_sec2_img_sm_8.jpg)"
                        }}
                      >
                        <img
                          src="/img/sub_company_sec2_img_bg.jpg"
                          className="basic_img"
                        />
                      </div>
                      <div className="txt">
                        <b>김대일</b>
                        <p>Advisor</p>
                      </div>
                    </li>
                    <li className="col-6 col-sm-4 col-md-3">
                      <div
                        className="img back_img normal_sh"
                        style={{
                          backgroundImage: "url(/img/sub_company_sec2_img_sm_9.jpg)"
                        }}
                      >
                        <img
                          src="/img/sub_company_sec2_img_bg.jpg"
                          className="basic_img"
                        />
                      </div>
                      <div className="txt">
                        <b>최종성</b>
                        <p>Advisor</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section> */}
          {/* //section2 */}
          <section className="section section4">
            <div className="container">
              <div className="sec_tit big faster" 
                // data-animate="fadeInUp"
              >
                <strong>Our History</strong>
              </div>
              {/* sec_tit */}
              <div className="sec_con">
                <div className="history_list">
                  <div className="box row">
                    <div className="year col">
                      <em>2025</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>9월</b>
                          </div>
                          <p>아이원 벤처기업 선정</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row">
                    <div className="year col">
                      <em>2024</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>4월</b>
                          </div>
                          <p>아이원 제3자 업무협약</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>2월</b>
                          </div>
                          <p>카드매출채권 상품 런칭</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row">
                    <div className="year col">
                      <em>2023</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>11월</b>
                          </div>
                          <p>전략적 지분 투자 유치</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>8월</b>
                          </div>
                          <p>(주)아이원 전략적 업무 협약</p>
                          <p>업계 최초 미술품 담보 상품 런칭</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row">
                    <div className="year col">
                      <em>2022</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>9월</b>
                          </div>
                          <p>매출채권 상품 런칭</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>6월</b>
                          </div>
                          <p>누적 투자액 1,500억 원 달성</p>
                          <p>특허 등록 (햅틱 감성정보로 변환하는 장치)</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>4월</b>
                          </div>
                          <p>축산물 담보 상품 런칭</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>1월</b>
                          </div>
                          <p>NH농협은행 제3자 예치기관 등록</p>
                          <p>원리금수취권 NFT 발행 아이원 앱 출시</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row">
                    <div className="year col">
                      <em>2021</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>12월</b>
                          </div>
                          <p>특허 등록</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>10월</b>
                          </div>
                          <p>누적 투자액 1,000억 원 달성</p>
                          <p>기술혁신형 중소기업 (이노비즈) 인증</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>8월</b>
                          </div>
                          <p>전략적 지분 투자 유치</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>7월</b>
                          </div>
                          <p>온라인투자연계금융업 라이선스 획득</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row no">
                    <div className="year col">
                      <em>2020</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>4월</b>
                          </div>
                          <p>누적 투자액 500억 원 달성</p>
                          <p>동산 담보 상품 런칭</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row no">
                    <div className="year col">
                      <em>2019</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>12월</b>
                          </div>
                          <p>누적 투자액 100억 원 달성</p>
                        </li>
                        <li>
                          <div className="month">
                            <b>10월</b>
                          </div>
                          <p>부동산 담보 상품 런칭</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row no">
                    <div className="year col">
                      <em>2018</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>8월</b>
                          </div>
                          <p>전자어음 채권 상품 런칭</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="box row no">
                    <div className="year col">
                      <em>2017</em>
                    </div>
                    <div className="month_list col">
                      <ul>
                        <li>
                          <div className="month">
                            <b>11월</b>
                          </div>
                          <p>아이원 설립</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* //history_list */}
                {/* <div className="btn_history">
                  <a href="javascript:;">
                    <img src="/img/sub_company_history_ico_plus.svg" />
                  </a>
                </div> */}
              </div>
              {/* //sec_con */}
            </div>
          </section>
          {/* //section4 */}
          {/* <section className="section section5">
            <div className="container thin">
              <div className="sec_tit big faster" data-animate="fadeInUp">
                <strong>Partnerships</strong>
                <p>와이펀드는 각 분야 최고의 회사들과 함께합니다.</p>
              </div>
              <div className="sec_con">
                <div className="partner_list partner_list_pc">
                  <ul className="clear">
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={100}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_1.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={200}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_2.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={300}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_3.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={400}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_4.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={500}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_5.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={600}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_6.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={700}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_7.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={800}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_8.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={900}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_9.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1000}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_10.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1100}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_11.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1200}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_12.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1300}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_13.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1400}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_14.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1500}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_15.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1600}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_16.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1300}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_17.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1400}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_18.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1500}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_19.jpg" />
                      </div>
                    </li>
                    <li
                      className="normal_sh faster"
                      data-animate="fadeInUp"
                      data-delay={1600}
                    >
                      <div className="img row_cen">
                        <img src="/img/main_sec8_logo_21.png" />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="partner_list swiper partner_list_swiper">
                  <ul className="swiper-wrapper">
                    <li className="swiper-slide">
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_1.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_2.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_3.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_4.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_5.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_6.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_7.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_8.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_9.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_10.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_11.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_12.jpg" />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_13.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_14.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_15.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_16.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_17.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_18.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_19.jpg" />
                          </div>
                        </div>
                        <div className="col normal_sh">
                          <div className="img row_cen">
                            <img src="/img/main_sec8_logo_21.png" />
                          </div>
                        </div>
                        <div className="col" />
                      </div>
                    </li>
                  </ul>
                  <div className="swiper-pagination partner_pagination" />
                </div>
              </div>
            </div>

          </section> */}
          <section className="main_venture">
            <div className="inner_wrap">
              <div className="text_wrap">
                <h3>
                  <em>벤처기업</em>
                  벤처기업 인증을 통한 신뢰와 기술력으로 안전한 결제를 제공합니다
                </h3>
                {/* <p>끊임 없는 협력과 최고를 향한 집념으로 공동의 목표를 달성하고 더 나은 가능성을 열어가겠습니다.</p> */}
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img src="/img/venture/venture.jpg" />
              </div>
            </div>
          </section>
          <section className="main_venture">
            <div className="inner_wrap">
              <div className="text_wrap">
                <h3>
                  <em>특허기업</em>
                  차별화된 기술력과 혁신으로 우수한 서비스를 제공합니다
                </h3>
                {/* <p>끊임 없는 협력과 최고를 향한 집념으로 공동의 목표를 달성하고 더 나은 가능성을 열어가겠습니다.</p> */}
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img src="/img/venture/patent.jpg" />
              </div>
              <br />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img src="/img/venture/ai.jpg" />
              </div>
            </div>
          </section>

          <section className="section section6">
            <div className="sec_tit big faster" 
              // data-animate="fadeInUp"
            >
              <div className="container">
                <strong>찾아오시는 길</strong>
                <p>인천광역시 부평구 주부토로 236 인천테크노밸리 U1센터 B동 922호</p>
              </div>
            </div>
            <div className="sec_con">
              <div className="container">
                <div className="media_q" />
                {/* <div className="msg_box normal_sh">
                  <div className="msg_tit">
                    <i>ADDRESS</i>
                    <em>
                      서울특별시 서초구 서초대로 396
                      <i className="inb" /> 강남빌딩 9층
                    </em>
                  </div>
                  <div className="msg_info">
                    <ul>
                      <li className="row_cen">
                        <div className="list_tit">
                          <b>이메일</b>
                        </div>
                        <div className="list_con">
                          <p>info@yfund.co.kr</p>
                        </div>
                      </li>
                      <li className="row_cen">
                        <div className="list_tit">
                          <b>고객센터</b>
                        </div>
                        <div className="list_con">
                          <p>1588-7637</p>
                        </div>
                      </li>
                      <li className="row_cen">
                        <div className="list_tit">
                          <b>업무시간</b>
                        </div>
                        <div className="list_con">
                          <p>09:00 - 18:00</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
              <div id="map" />
            </div>
          </section>
        </div>
      </div>

    </>
  )
}